module.exports = __webpack_public_path__ + "img/IMG_0328_L_Wood_MockedUp.6ce65db4.jpg";